import React, { useState, useEffect, useCallback,useRef } from "react";
import { Popup, TextBox, Button } from 'devextreme-react';
import '../css/omstyle.css'

import axios from "axios";
import data from "../../assets/apiRoutes.json";
import {
    Column,
    DataGrid,
    Sorting,
    Paging,
    Pager,
    LoadPanel,
    ColumnHeaderFilter,
    Selection,
} from "devextreme-react/data-grid";
import Toolbar, { Item } from "devextreme-react/toolbar";

import { connect } from "react-redux";
//import Item from "../../so/components/Calculators/BareRootPickListItem";
import AccordionReact from 'devextreme-react/accordion';
const searchpanel = [
    {
        ID: 1,
        Title: 'Search Filters'
    }
];
const LookupSearchDialog = (props) => {
    const { setReceipt, receipt, lookupFormName, lookup, setTransactionLookupData, transactionSelectedLookupData, setTransactionLookupSelectedData, selectedCustomer, showOnlyConsigneeAttachedToCustomers, showOnlyShippersAttachedToCustomer  } = props;
    const dataGrid = useRef(null);
    var accessToken = props.oidc.user.access_token;
    const [lookupDataList, setLookupDataList] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [searchPanelStatus, setSearchPanelStatus] = useState(true);
    const [selectedItems, setSelectedItems] = useState([searchpanel[0]]);
    let [lookupSearchRequest, setLookupSearchRequest] = useState({
        identityIdFrom: lookup.name.endsWith("From") && transactionSelectedLookupData?.identityId != undefined ? transactionSelectedLookupData?.identityId : "",
        identityIdTo: lookup.name.endsWith("To") && transactionSelectedLookupData?.identityId != undefined ? transactionSelectedLookupData?.identityId : "",
        name: "",
        CustomerId: selectedCustomer,
        code: transactionSelectedLookupData?.code != undefined ? transactionSelectedLookupData?.code : "",
        description: transactionSelectedLookupData?.description != undefined ? transactionSelectedLookupData?.description : "",
        lookupType: lookup.lookupType,
        showOnlyConsigneeAttachedToCustomers: showOnlyConsigneeAttachedToCustomers,
        showOnlyShippersAttachedToCustomer: showOnlyShippersAttachedToCustomer,
    });
    const selectionChanged = useCallback(
        (e, tg) => {
            let newItems = [...selectedItems];
            e.removedItems.forEach((item) => {
                const index = newItems.indexOf(item);
                if (index >= 0) {
                    newItems.splice(index, 1);
                }
            });
            if (e.addedItems.length) {
                newItems = [...newItems, ...e.addedItems];
            }
            setSelectedItems(newItems);
            setSearchPanelStatus((prevStatus) => {
                const newStatus = !prevStatus;
                return newStatus;
            });
        },
        [selectedItems, setSelectedItems],
    );
    const closeLookupSearchForm = () => {
        props.setOpenLookupForm(false);
        setLookupSearchRequest({
            identityIdFrom: "",
            identityIdTo: "",
            name: "",
            code: "",
            CustomerId: "",
            description: "",
            lookupType: lookup.lookupType,
            showOnlyConsigneeAttachedToCustomers: showOnlyConsigneeAttachedToCustomers,
            showOnlyShippersAttachedToCustomer: showOnlyShippersAttachedToCustomer,
        });
    };
    const { identityIdFrom, identityIdTo, name, code, description } = lookupSearchRequest;
    
const onLookupFieldChange = useCallback((e, name) => {
    setLookupSearchRequest(prevState => ({
      ...prevState,
      [name]: e.value,
    }));
  }, [setLookupSearchRequest]);
    const getAllLookupsData = useCallback(() => {
        axios
            .post(
                `${window._env_.REACT_APP_APIS}/${data.OM.SearchLookup}`,
                lookupSearchRequest,
                {
                    headers: {
                        "Content-Type": "application/json",
                        access_token: accessToken,
                    },
                }
            )
            .then((res) => {
                console.log(res, "res");
                if (res.data.lookups.length === 0) {
                    setIsLoading(false);
                }
                setLookupDataList(res.data.lookups);

            })
            .catch((err) => {
                setIsLoading(false);
                console.log(err, "err in loading lookups data");
            });
    });
    const onSearchLookupIds = () => {
        getAllLookupsData();
    };
    useEffect(() => {
        getAllLookupsData();
    }, []);
    const resetLookupForm = () => {
        lookupSearchRequest = {
            identityIdFrom: "",
            identityIdTo: "",
            name: "",
            code: "",
            CustomerId: "",
            description: "",
            lookupType: lookup.lookupType,
            showOnlyConsigneeAttachedToCustomers: showOnlyConsigneeAttachedToCustomers,
            showOnlyShippersAttachedToCustomer: showOnlyShippersAttachedToCustomer
        };
        setLookupSearchRequest({
            identityIdFrom: "",
            identityIdTo: "",
            code: "",
            description: "",
            name: "",
            CustomerId: "",
            lookupType: lookup.lookupType,
            showOnlyConsigneeAttachedToCustomers: showOnlyConsigneeAttachedToCustomers,
            showOnlyShippersAttachedToCustomer: showOnlyShippersAttachedToCustomer
        });
    }
    const onSelectionChanged = ({ selectedRowsData }) => {
        let selectedLookupData = selectedRowsData;

        if (lookupFormName === "ConsigneeFrom") {
            setReceipt({
                ...receipt,
                rConsigneeFrom: selectedLookupData[0].rowid,
                consigneenamefrom: selectedLookupData[0].name
            })
            setTransactionLookupSelectedData(selectedLookupData[0]);
            setTransactionLookupData(selectedRowsData);
        } else if (lookupFormName === "ConsigneeTo") {
            setReceipt({
                ...receipt,
                rConsigneeTo: selectedLookupData[0].rowid,
                consigneenameto: selectedLookupData[0].name
            })
            setTransactionLookupSelectedData(selectedLookupData[0]);
            setTransactionLookupData(selectedRowsData);
        }
        else if (lookupFormName === "ShipperTo") {
            setReceipt({
                ...receipt,
                rShipperTo: selectedLookupData[0].rowid,
                shippernameto: selectedLookupData[0].name
            })
            setTransactionLookupSelectedData(selectedLookupData[0]);
            setTransactionLookupData(selectedRowsData);
        }
        else if (lookupFormName === "CustomerFrom") {

            setReceipt({
                ...receipt,
                rCustomerFrom: selectedLookupData[0].rowid,
                customernamefrom: selectedLookupData[0].name
            })
            setTransactionLookupSelectedData(selectedLookupData[0]);
            setTransactionLookupData(selectedRowsData);
        }
        else if (lookupFormName === "ShipperFrom") {
            setReceipt({
                ...receipt,
                rShipperFrom: selectedLookupData[0].rowid,
                shippernamefrom: selectedLookupData[0].name
            })
            setTransactionLookupSelectedData(selectedLookupData[0]);
            setTransactionLookupData(selectedRowsData);
        }
        else if (lookupFormName === "ShipperVia") {
            setReceipt({
                ...receipt,
                rShipperVia: selectedLookupData[0].rowid,
                shippernameVia: selectedLookupData[0].name
            })
            setTransactionLookupSelectedData(selectedLookupData[0]);
            setTransactionLookupData(selectedRowsData);
        }
        if (lookupFormName === "Profile") {
            setReceipt({
                ...receipt,
                rProfile: selectedLookupData[0].rowid,
                profileVal: selectedLookupData[0].code
            })
            setTransactionLookupSelectedData(selectedLookupData[0]);
            setTransactionLookupData(selectedRowsData);
        }
    };
    return (
        <div>
            <Popup
                visible={props.openLookupForm}
                onHiding={closeLookupSearchForm}
                showCloseButton={true}
                title={lookup.lookupType===5?"Ship To"+ " Lookup Form":lookupFormName + " Lookup Form"}
            >
                <div className="row">
                    <div className="col-md-12 main-page">
                        <div id="accordion" >
                            <AccordionReact
                                dataSource={searchpanel}
                                collapsible={true}
                                multiple={false}
                                animationDuration={300}
                                selectedItems={selectedItems}
                                onSelectionChanged={e => {
                                    if (e.currentTarget === e.target) {
                                        selectionChanged(e, e.target);
                                    }
                                }}
                                itemTitleRender={() => (
                                    <Toolbar className="accordian-toolbar">
                                        <Item location="after">
                                            <Button className="accordianButton" text="Search"
                                                onClick={onSearchLookupIds}
                                                type="default"
                                            />
                                        </Item>
                                        <Item location="after">
                                            <Button className="accordianButton" text="Reset"
                                                onClick={resetLookupForm}
                                            />
                                        </Item>
                                        <Item location="after">
                                            <Button className="accordianButton" text="Done"
                                                onClick={closeLookupSearchForm}
                                            />
                                            
                                        </Item>
                                    </Toolbar>

                                )}
                                itemRender={(itemProps) => (
                                    <div>
                                        {lookupFormName === "Profile" ? (
                                            <form>
                                                <div className="row">
                                                    <div className="col-md-3">
                                                        <TextBox
                                                            stylingMode='outlined'
                                                            labelMode="static"
                                                            label="Enter Code4444"
                                                            defaultValue=""
                                                            value={code}
                                                            onValueChanged={(e) => onLookupFieldChange(e, "code")}
                                                            style={{marginBottom:"5px"}}
                                                        />

                                                    </div>
                                                    <div className="col-md-3">
                                                        <TextBox
                                                            stylingMode='outlined'
                                                            labelMode="static"
                                                            label="Enter Description"
                                                            defaultValue=""
                                                            value={description}
                                                            onValueChanged={(e) => onLookupFieldChange(e, "description")}
                                                            style={{marginBottom:"5px"}}
                                                        />

                                                    </div>

                                                </div>
                                            </form>
                                        ) : (
                                            <form>
                                                <div className="row">
                                                    <div className="col-md-3">
                                                        <TextBox
                                                            stylingMode='outlined'
                                                            labelMode="static"
                                                            label="Enter Identity Id From"
                                                            defaultValue=""
                                                            value={identityIdFrom}
                                                            onValueChanged={(e) => onLookupFieldChange(e, "identityIdFrom")}
                                                            style={{marginBottom:"5px"}}
                                                        />
                                                    </div>
                                                    <div className="col-md-3">
                                                        <TextBox
                                                            stylingMode='outlined'
                                                            labelMode="static"
                                                            label="Enter Identity Id To"
                                                            defaultValue=""
                                                            value={identityIdTo}
                                                            onValueChanged={(e) => onLookupFieldChange(e, "identityIdTo")}
                                                            style={{marginBottom:"5px"}}
                                                        />
                                                    </div>
                                                    <div className="col-md-3">
                                                        <TextBox
                                                            stylingMode='outlined'
                                                            labelMode="static"
                                                            label="Enter  Name"
                                                            defaultValue=""
                                                            value={name}
                                                            onValueChanged={(e) => onLookupFieldChange(e, "name")}
                                                            style={{marginBottom:"5px"}}
                                                        />

                                                    </div>
                                                </div>
                                            </form>
                                        )}
                                    </div>
                                )}
                                id="accordion-container" className="accordion-height"
                            />
                        </div>
                    </div>
                </div>

                {lookupFormName === "Profile" ? (
                    <DataGrid

onExporting={(e) => {
          if (window.handleDevExtremeDataGridExport) {
            window.handleDevExtremeDataGridExport(e);
          }
        }}
                        ref={dataGrid}
                        noDataText={isLoading ? "Loading" : "No Data"}
                        dataSource={lookupDataList}
                        showBorders={true}
                        className={searchPanelStatus?'Popup-GridHeightAccordianOpen':'Popup-GridHeightAccordianClose'}
                        hoverStateEnabled={true}
                        allowColumnResizing={true}
                        allowColumnReordering={false}
                        rowAlternationEnabled={false}
                        onSelectionChanged={(e) => onSelectionChanged(e)}
                        showRowLines={true}
                        showColumnLines={false}
                    >
                        <ColumnHeaderFilter />
                        <LoadPanel enabled={true} />
                        <Selection mode="multiple" />
                        <Paging defaultPageSize={10} />
                        <Sorting visible={false} />
                        <Pager
                            visible={true}
                            showPageSizeSelector={true}
                            allowedPageSizes={[10, 20, 50, 500, 1000, "all"]}
                            showNavigationButtons={true}
                        />
                        <Column dataField="code" caption="Code"></Column>
                        <Column dataField="description" caption="Description"></Column>
                    </DataGrid>
                ) : (
                    <DataGrid

onExporting={(e) => {
          if (window.handleDevExtremeDataGridExport) {
            window.handleDevExtremeDataGridExport(e);
          }
        }}
                        ref={dataGrid}
                        noDataText={isLoading ? "Loading" : "No Data"}
                        dataSource={lookupDataList}
                        showBorders={true}
                        className={searchPanelStatus?'Popup-GridHeightAccordianOpen':'Popup-GridHeightAccordianClose'}
                        hoverStateEnabled={true}
                        allowColumnResizing={true}
                        allowColumnReordering={false}
                        rowAlternationEnabled={false}
                        onSelectionChanged={(e) => onSelectionChanged(e)}
                        showRowLines={true}
                        showColumnLines={false}
                    >
                        <ColumnHeaderFilter />
                        <LoadPanel enabled={true} />
                        <Selection mode="multiple" />
                        <Paging defaultPageSize={10} />
                        <Sorting visible={false} />
                        <Pager
                            visible={true}
                            showPageSizeSelector={true}
                            allowedPageSizes={[10, 20, 50, 500, 1000, "all"]}
                            showNavigationButtons={true}
                        />
                        <Column
                            dataField="identityId"
                            caption="Identity ID"
                        ></Column>
                        <Column dataField="name" caption="Name"></Column>
                        <Column dataField="address1" caption="Address 1"></Column>
                        <Column dataField="address2" caption="Address 2"></Column>
                        <Column dataField="city" caption="City"></Column>
                        <Column dataField="state" caption="State"></Column>
                        <Column dataField="zipCode" caption="Zip"></Column>
                        <Column dataField="country" caption="Country"></Column>
                        <Column dataField="telephone" caption="Telephone"></Column>
                        <Column
                            dataField="addressMemo"
                            caption="Address Memo"
                            width={200}
                        ></Column>
                    </DataGrid>
                )}


            </Popup>
        </div>
    )
}
function mapStateToProps(state) {
    return {
        ReceiptReducer: state.ReceiptReducer,
        oidc: state.oidc,
    };
}
export default connect(mapStateToProps)(LookupSearchDialog);